import { render, staticRenderFns } from "./ships-dates-prices-list.vue?vue&type=template&id=75c95a70"
import script from "./ships-dates-prices-list.vue?vue&type=script&lang=js"
export * from "./ships-dates-prices-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports